// extracted by mini-css-extract-plugin
export default {"header":"MagicLink_header__6J6o7","headline":"MagicLink_headline__UcMAE","helper":"MagicLink_helper__nwAqI","sentTo":"MagicLink_sentTo__HnrBk","btnRow":"MagicLink_btnRow__kLMSP"};